import { StyledBannerImage } from '#/components/shared/ui/banner/styles';

export default function BannerImage({ image }: { image: string }) {
  return <StyledBannerImage src={image} alt="banner" />;
}
